import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import baseURL, { endPoints } from '../../Config';
import { impersonationActive } from '../../service/impersonation';

const normalizePreferredLanguage = (payload) => {
    const nextPayload = payload ? JSON.parse(JSON.stringify(payload)) : payload;
    const adminUser = nextPayload?.data?.adminUser;
    if (!adminUser) return nextPayload;

    if (adminUser.preferredLanguage !== 'en' && adminUser.preferredLanguage !== 'es') {
        adminUser.preferredLanguage = 'es';
    }

    if (nextPayload?.data?.accessToken && !nextPayload?.data?.token) {
        nextPayload.data.token = nextPayload.data.accessToken;
    }

    return nextPayload;
};

const persistLoginPayload = (payload) => {
    if (!payload) return;
    localStorage.setItem('userDetails', JSON.stringify(payload));
    localStorage.setItem('adminUser', JSON.stringify(payload));

    if (typeof window !== 'undefined') {
        window.dispatchEvent(
            new CustomEvent('preferred-language-changed', {
                detail: {
                    preferredLanguage: payload?.data?.adminUser?.preferredLanguage || 'es'
                }
            })
        );
    }
};

const initialState = {
    user: localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : null,
    loading: false,
    error: null
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        logout(state) {
            localStorage.removeItem('userDetails');
            localStorage.removeItem('adminUser');
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(Userlogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(Userlogin.fulfilled, (state, action) => {
                state.loading = false;
                const payload = normalizePreferredLanguage(action.payload);
                state.user = payload;
                persistLoginPayload(payload);
            })
            .addCase(Userlogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const Userlogin = createAsyncThunk('auth/portal-login', async ({ navigate, formData }, { rejectWithValue }) => {
    if (impersonationActive()) {
        toast.error('Vuelve a tu cuenta o cierra la impersonación antes de iniciar sesión.');
        return rejectWithValue('Impersonación activa');
    }
    try {
        let response = null;
        // if (isUser) {
        response = await axios.post(`${baseURL}${endPoints.login}`, formData);
        // }
        // else {
        //     response = await axios.post(`${config.baseUrl}${endPoints.customerLogin}`, formData);
        // }

        if (response.data) {
            const normalizedPayload = normalizePreferredLanguage(response.data);
            persistLoginPayload(normalizedPayload);
            toast.success(response?.data?.message, { autoClose: 1000 }); // Toast will disappear in 2 seconds
            const mustChangePassword = Boolean(normalizedPayload?.data?.adminUser?.mustChangePassword);
            navigate(mustChangePassword ? '/force-password' : '/');
            return normalizedPayload;
        }
        // {
        //     localStorage.setItem('isCustomer', isUser ? 'false' : 'true');
        // }
    } catch (error) {
        const errorMessage = error.response && error.response.data.msg ? error.response.data.msg : error.message;
        toast.error(error.response?.data.message, { autoClose: 1000 }); // Error toast
        return rejectWithValue(errorMessage);
    }
});

export const { logout, setUser } = loginSlice.actions;

export default loginSlice.reducer;
